
import React, { useEffect, useState, useRef } from 'react';
import '../styles/Header.css';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from "../context/UserContext";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { user, logout} = useUser();
  
  const handleNavigate = (link) =>{
    navigate(link);
  }
  

  // Handle scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setScrolled(false); // top of page
      } else {
        setScrolled(true); // any scroll movement
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className={scrolled ? 'scrolled' : ''}>
      <div className="logo"  onClick={() => handleNavigate('/')}> <img src='/images/logo.png'></img></div>

      <nav className="nav-links">
        <a href="/">Home</a>
        <a href="/solutions">Solutions</a>
        <a href="/pricing">Pricing</a>
        <a href="/about">About</a>
        <a href="/contact">Contact</a>
      </nav>

      <div
        className={`login-dropdown ${dropdownOpen ? 'open' : ''}`}
        ref={dropdownRef}
      >
        <i
          className="bi bi-person-lock login-icon"
          onClick={() => user ? setDropdownOpen(true) : handleNavigate('/login')}
        ></i>

        <div className="custom-dropdown-menu">
          <span>{user?.fullName}</span>
          <span onClick={() => handleNavigate('/choose-profile')}>My Profiles</span>
          <span onClick={() => handleNavigate('/solutions')}>Register Business</span>
          <span className='btn-outline text-danger text-center' onClick={() => logout()}>Log out</span>
        </div>
      </div>
    </header>
  );
}

export default Header;
